import React, { useEffect, useState } from 'react';
import '../CSS/Highlights.css';

const REPORT_TYPE = 'Situational Reports';

function logHighlightClick(reportName) {
  const userEmail = localStorage.getItem('user-email');
  if (!userEmail) return;

  const payload = { reportName, reportType: REPORT_TYPE, userEmail };

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon('/api/log-report', blob);
    } else {
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload)
      }).catch(() => {});
    }
  } catch {}
}

const Highlights = () => {
  const [Spotlight, setSpotlight] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const addProxyUrls = (items) => {
    return (items || []).map(item => {
      const pdfFileName = item.originalName || `${item.name}.pdf`;

      return {
        ...item,
        proxyUrl: `/api/highlights/Spotlight/${encodeURIComponent(pdfFileName)}`
      };
    });
  };

  useEffect(() => {
    let mounted = true;

    fetch('/api/hello', {
      credentials: 'include',
      cache: 'no-store',
    })
      .then((r) => r.json())
      .then((data) => {
        if (!mounted) return;


        const spotlightWithProxy = addProxyUrls(data.Spotlight);

        setSpotlight(spotlightWithProxy);
        setFilteredData(spotlightWithProxy);
      })
      .catch((err) => console.error('Error fetching reports data:', err))
      .finally(() => mounted && setLoading(false));

    return () => { mounted = false; };
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim()) {
      const t = term.toLowerCase();
      setFilteredData(
        Spotlight.filter((item) =>
          item.name?.toLowerCase().includes(t)
        )
      );
    } else {
      setFilteredData(Spotlight);
    }
  };

  if (loading) {
    return (
      <div className="highlights">
        <h1>Situational Reports</h1>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="highlights">
<div className="reports-hero">
  <div className="reports-hero-content">
    <p className="reports-eyebrow">Orion Intelligence Library</p>

    <h1>Situational Reports</h1>

    <p className="reports-hero-description">
      In-depth intelligence reports encompassing detailed analyses of notable incidents,
      ongoing campaigns, developments within activist organizations, strategic tactics employed,
      and related subjects, providing a comprehensive understanding of the landscape and trends
      in activist activities.
    </p>

    <div className="reports-hero-search">
      <label>
        Search Reports
        <input
          type="text"
          placeholder="Search by title..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </label>
    </div>
  </div>

  <div className="reports-hero-count">
    <span>{filteredData.length}</span>
    <p>Reports</p>
  </div>
</div>

      <div className="spotlight-grid">
        {filteredData.map((item, index) => {
          const cleanName = (item.name || '').replace(/\.pdf$/i, '');
          const hasCover = Boolean(item.coverImageUrl);

          return (
            <div className="spotlight-card" key={item.driveItemId || item.id || index}>
              <a
                href={item.proxyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="spotlight-image-link"
                onClick={() => logHighlightClick(cleanName)}
              >
                {hasCover ? (
                  <img
                    src={item.coverImageUrl}
                    alt={item.name}
                    className="spotlight-cover-image"
                    onError={(e) => {
                      console.error('Cover image failed:', item.coverImageUrl);
                      e.currentTarget.style.display = 'none';
                      const fallback = e.currentTarget.nextElementSibling;
                      if (fallback) fallback.style.display = 'flex';
                    }}
                  />
                ) : null}

                <div
                  className="spotlight-cover-fallback"
                  style={{ display: hasCover ? 'none' : 'flex' }}
                >
                  <span>PDF</span>
                </div>
              </a>

              <div className="spotlight-card-body">

                {item.createdDateTime && (
                  <p className="spotlight-date">
                    {new Date(item.createdDateTime).toLocaleDateString()}
                  </p>
                )}

                <a
                  href={item.proxyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="spotlight-title-link"
                  onClick={() => logHighlightClick(cleanName)}
                >
                  {item.name}
                </a>

              </div>
            </div>
          );
        })}
      </div>

      {filteredData.length === 0 && <p>No reports found.</p>}
    </div>
  );
};

export default Highlights;